import React from 'react';
import { Button } from 'baseui/button';
import { Textarea } from 'baseui/textarea';
import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';

import { ConfirmationModal, KeyValueEnteringGuide } from 'commons-ui';

import Editor from '../../utils/Editor';
import useEdit from './useEdit';

const Edit: React.FC<{}> = () => {
	const {
		PICKER_VALUES,
		pickerValue,
		newKeyValue,
		keyName,
		keyValue,
		description,
		confirmationModal,
		hasEditPermission,
		setPickerValue,
		handleKeyEdit,
		handleResetChanges,
		handleEnterDescription,
		handleKeyUpdate,
		handleKeyCancel
	} = useEdit();

	const [css] = useStyletron();
	const space = css({ marginRight: '20px' });

	return (
		<div className={css({ padding: '20px', overflow: 'auto', height: 'calc(100% - 110px)' })}>
			<h1>Update Key</h1>
			<div className={css({ marginTop: '10px' })}>
				<span className={css({ fontWeight: 'bold' })}>{`Current Key Name: ${keyName}`}</span>
			</div>
			<div className={css({ marginTop: '10px' })}>
				<span className={css({ fontWeight: 'bold' })}>{`Current Key Value:  ${keyValue}`}</span>
			</div>

			{hasEditPermission && (
				<div className={css({ display: 'flex', alignItems: 'center' })}>
					<div
						className={css({
							fontSize: '18',
							fontWeight: 'bold',
							marginRight: '10px'
						})}>
						Please Select the Key Type{' '}
					</div>
					<div
						className={css({
							width: '200px'
						})}>
						<Select
							options={PICKER_VALUES}
							placeholder='Select Key Type'
							onChange={(params) => {
								setPickerValue(params.value);
							}}
							labelKey='id'
							value={pickerValue}
						/>
					</div>
				</div>
			)}

			<Editor
				keyValue={newKeyValue}
				handleChangeText={handleKeyEdit}
				pickerValue={pickerValue}
				hasEditPermission={hasEditPermission}
			/>

			<div className={css({ margin: '10px 0' })}>
				<Textarea
					value={description}
					onChange={(e) => handleEnterDescription(e.currentTarget.value)}
					placeholder='Enter Reason for change here'
					overrides={{
						Input: {
							style: {
								maxHeight: '200px',
								minHeight: '100px',
								minWidth: '300px',
								width: '100vw', // fill all available space up to parent max-width
								resize: 'both'
							}
						},
						InputContainer: {
							style: {
								maxWidth: '100%',
								width: 'min-content'
							}
						}
					}}
					disabled={!hasEditPermission}
				/>
			</div>
			<div className={css({ display: 'flex', justifyContent: 'space-between', padding: '10px 0px' })}>
				<Button onClick={handleResetChanges}>Reset Changes</Button>
				<div>
					<Button onClick={handleKeyCancel}>Cancel</Button>
					<span className={space} />
					{hasEditPermission && <Button onClick={handleKeyUpdate}>Update</Button>}
				</div>
			</div>
			<KeyValueEnteringGuide />
			{confirmationModal.show && (
				<ConfirmationModal
					confirmationHeader={confirmationModal.header}
					onClose={confirmationModal.handleAlertCancel}
					confirmationDialogOnAgree={confirmationModal.handleAlertConfirmation}
					confirmationMessage={confirmationModal.message}
				/>
			)}
		</div>
	);
};

export default Edit;
